module.exports = __webpack_public_path__ + "static/media/black-loader-transperent.cff1dd20.gif";